import { useSelector } from 'react-redux';
import { getCasesForBattleByIds } from '../ducks';

export const useGetCasesByIds = (caseId?: number) => {
  const { isLoading, data } = useSelector(getCasesForBattleByIds);
  const caseData = data.find(({ id }) => id === caseId);
  return { isLoading, caseData };
};
